import { Pipe, PipeTransform } from '@angular/core';

import { Util } from './common.util';

@Pipe({
    name: 'cmpsNgbDate',
})
export class CmpsNgbDatePipe implements PipeTransform {
    transform(value: any, ...args: any[]): any {
        return Util.dateToDate(value);
    }
}

@Pipe({
    name: 'cmpsSelectLabel',
})
export class CmpsSelectLabelPipe implements PipeTransform {
    transform(value: any, set: any, searchKey: any, valueKey: any): any {
        let res = '';
        if (set == null || set.length === 0) return res;
        const obj = set.find((item) => item[searchKey] === value);
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        if (obj != null && obj[valueKey] != null) {
            res = obj[valueKey];
        }
        return res;
    }
}
